<template>
  <div class="feature-4" :class="{more: moreOpened}" v-scroll-animate>

    <div class="feature-header lead-1-large">
      <div v-html="feature.title"></div>
    </div>

    <div class="feature-content-wrapper">
      <div class="feature-icon">
        <img :src="feature.image" alt="">
      </div>
      <div ref="text" class="feature-box-title paragraph-1" v-html="feature.subTitle"></div>
      <div class="button-container" v-if="feature.buttonLabel">
        <seu-button
          :label="moreOpened? feature.buttonLabelLess: feature.buttonLabel"
          :button-link="feature.buttonLink"
          :button-icon-after="rightArrow"
          @click="toggleMore"
        />
      </div>
      <div class="button-container" v-else-if="overflow">
        <seu-button
          :label="moreOpened?  $t('common.less'): $t('common.more')"
          :button-icon-after="rightArrow"
          @click="toggleMore"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

function isEllipsisActive(element) {
  let pBottom = parseInt(document.defaultView.getComputedStyle(element, "").getPropertyValue('padding-bottom')) || 0;

  if (element.clientHeight < (element.scrollHeight - pBottom - 10)) {
    return true
  }
  return false;
}

export default {
  name: 'Feature4',
  components: {SeuButton},
  props: {
    feature: {
      type: Object
    }
  },
  data: () => ({
    rightArrow: require('../../assets/icons/arrow-triangle-down.svg'),
    moreOpened: false,
    overflow: false
  }),

  methods: {
    toggleMore() {
      this.moreOpened = !this.moreOpened
    }
  },

  mounted() {
    this.overflow = isEllipsisActive(this.$refs.text)
  }

}
</script>

<style lang="scss">
@import "Feature4";
</style>
